const PROD_URL = "https://us-central1-planning-360.cloudfunctions.net/api";

exports.BACKEND_URL = process.env.VUE_APP_BACKEND_URL
  ? process.env.VUE_APP_BACKEND_URL
  : PROD_URL;

// exports.BACKEND_URL = PROD_URL;
